import baseMessage from './baseMessage'

export const ES_EC = {
  message: {
    ...baseMessage,
    label: {
      dni: 'Cédula de Identidad',
      userHint: 'Se puede buscar por Nombres, Apellidos, Cédula de Identidad'
    }
  }
}
